export const server = "https://mychart.pacmny.com/pacmny-be/web/index.php";
export const domRoot = "https://mychart.pacmny.com";